import { Navigate } from "react-router-dom";
import { useAdmin } from "@/context/AdminContext";

export default function RequireOwner({ children }) {
    const { isOwner } = useAdmin();
    if (!isOwner) return <Navigate to="/admin" replace />;
    return children;
}
